import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { Observable, filter, map, of, pipe, switchMap, tap } from 'rxjs';

import { Pipe, PipeTransform } from '@angular/core';
import { MineFontsGQL } from 'ZalamoLibrary/src/lib/ui/fonts-manager/graphql';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';

import { localFontList } from '@ui/fonts-manager/localFontList';

@Pipe({
  name: 'fontName',
  standalone: false,
})
export class FontNamePipe implements PipeTransform {
  constructor(
    private mineFontsGQL: MineFontsGQL,
    private organizationService: OrganizationService,
  ) {}

  transform(fontId: string, ...args: unknown[]): Observable<string> {
    if (fontId?.startsWith('local-')) {
      return of(localFontList.find((font) => font.fontId === fontId)?.name);
    }
    return this.organizationService.getCurrentOrganization().pipe(
      switchMap((organizationId) =>
        this.mineFontsGQL
          .watch({ variables: { organizationId } })
          .valueChanges.pipe(
            throwOnQueryError,
            filter(hasCompleteQueryData),
            map((result) => result.data['mineFonts']['fonts']),
            tap((x) => console.log(x)),
            map((fonts) => fonts.find((font) => font.fontId === fontId)?.name),
            tap((x) => console.log(x)),
          ),
      ),
    );
  }
}
